import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ComparisonTable from "components/asset-management/comparison/comparison-table"
// Data
import api_match from "data/interface/api"
import comparisonService, { Comparison } from "data/comparison"
import { alphanum } from "components/table/lib/sort"
//Styles
import { Comparison_s } from "components/asset-management/comparison/comparison-styles"
import { AddIcon } from "images/icons/tools"

const ComparisonComponent: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<Comparison[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)

  const tableId = "comparison-table"

  useEffect(() => {
    const comparisonSubscription = comparisonService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    comparisonService.fetchComparisons()

    return function cleanup() {
      comparisonSubscription.unsubscribe()
    }
  }, [initSort])

  const Add = () => {
    return (
      <a onClick={() => comparisonService.create()}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <Comparison_s>
      <Toolbar>
        <Add />
      </Toolbar>
      { data &&
        <ComparisonTable tableId={tableId} data={data} />
      }
    </Comparison_s>
  )
}

export default ComparisonComponent
